import { RouterProvider } from 'react-router-dom'
import { router } from './router'
import { QueryProvider } from '@/providers/QueryProvider'
import { SessionProvider } from '@/contexts/SessionProvider'
import { GlobalLoadingProvider } from '@/contexts/GlobalLoadingContext'

function App() {
  return (
    <QueryProvider>
      <SessionProvider>
        <GlobalLoadingProvider>
          <RouterProvider router={router} />
        </GlobalLoadingProvider>
      </SessionProvider>
    </QueryProvider>
  )
}

export default App

